import { Text, View } from '@react-pdf/renderer';

const Skills = ({ styles, data, headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>
			<View style={styles.skills}>
				{data?.map((res: any) => (
					<View key={`skills-t1-${res?.title}`} style={styles.skills}>
						<View style={styles.skillsBox}>
							<Text style={styles.skillsText}>{res?.title}</Text>
						</View>
					</View>
				))}
			</View>
		</View>
	);
};

export default Skills;
